import React from 'react';
import withIcon from '../utilities/withIcon';

const IconTrash = () => {
  return (
    <g>
      <path d="m15.0019 2.9858h-3.9575v-1.1093a1.82 1.82 0 0 0 -1.8178-1.8179h-2.4532a1.82 1.82 0 0 0 -1.8178 1.8179v1.1093h-3.9576a.75.75 0 0 0 0 1.5h1.0365l.2917 9.6548a1.7922 1.7922 0 0 0 1.7529 1.8008h7.7524a1.793 1.793 0 0 0 1.7525-1.7814l.38-9.6738h1.038a.75.75 0 1 0 0-1.5zm-8.5463-1.1093a.3182.3182 0 0 1 .3179-.3179h2.4531a.3182.3182 0 0 1 .3179.3179v1.1093h-3.0889zm5.6294 12.2285a.3163.3163 0 0 1 -.2534.3364h-7.7525c-.1182 0-.2485-.1367-.2539-.3428l-.29-9.6128h8.9276z" />
      <path d="m6.3779 6.1816a.75.75 0 0 0 -.75.75v4.8477a.75.75 0 0 0 1.5 0v-4.8477a.75.75 0 0 0 -.75-.75z" />
      <path d="m9.6221 6.1816a.75.75 0 0 0 -.75.75v4.8477a.75.75 0 1 0 1.5 0v-4.8477a.75.75 0 0 0 -.75-.75z" />
    </g>
  );
};

export default withIcon(IconTrash);
